import ProductGradeFilter from "component/category/filter/ProductGradeFilter";

/*
diameter, width, boltPatterns, offset, color: https://partsavatar.ca/wheels-rims, https://partsavatar.ca/wheels-tires-packages
*/

const sizeOrder = {
  XS: 0, S: 1, M: 2, L: 3, XL: 4, "2XL": 5, "3XL": 6, "4XL": 7,
};

export const FILTER_CONFIG = {
  merchandiseColors: {
    type: "checkbox",
    order: 1,
    title: "Color",
    filterKey: "merchandiseColors",
    multiple: true,
    className: "product-list-filter-fitment",
    scrolling: true,
    sorter: (a: any, b: any) => (a.bucket.localeCompare(b.bucket)),
  },
  merchandiseSizes: {
    type: "checkbox",
    order: 2,
    title: "Size",
    filterKey: "merchandiseSizes",
    multiple: true,
    className: "product-list-filter-fitment",
    scrolling: true,
    sorter: (a: any, b: any) => {
      const orderA = sizeOrder[a.bucket];
      const orderB = sizeOrder[b.bucket];
      return orderA - orderB;
    },
  },
  airFreshenerColors: {
    type: "checkbox",
    order: 2,
    title: "Air Freshener Color",
    filterKey: "airFreshenerColors",
    multiple: true,
    className: "product-list-filter-fitment",
    scrolling: true,
  },
  airFreshenerScents: {
    type: "checkbox",
    order: 2,
    title: "Scent",
    filterKey: "airFreshenerScents",
    multiple: true,
    className: "product-list-filter-fitment",
    scrolling: true,
  },
  productTags: {
    type: "checkbox",
    order: 1,
    title: ProductGradeFilter,
    filterKey: "productTags",
    multiple: true,
  },
  tireSummary: {
    type: "tireSummary",
    order: 2,
    title: "Tire Size",
    enabled: true,
    forceRender: true,
  },
  // engines: {
  //   type: "checkbox",
  //   order: 2,
  //   title: EngineFilter,
  //   filterKey: "engine",
  //   multiple: false,
  //   collapsible: false,
  // },
  descriptions: {
    type: "checkbox",
    order: 3,
    title: "Product",
    filterKey: "description",
    className: "product-checkbox-filter-descriptions",
  },
  sizes: {
    type: "checkbox",
    order: 6,
    title: "Size",
    filterKey: "sizes",
    multiple: true,
    className: "product-list-filter-fitment",
    scrolling: true,
    sorter: (a: any, b: any) => parseInt(a.bucket.slice(-2), 10) - parseInt(b.bucket.slice(-2), 10),
  },
  seasons: {
    type: "checkbox",
    order: 6,
    title: "Tire Season",
    filterKey: "seasons",
    multiple: true,
    className: "product-list-filter-fitment",
    scrolling: false,
  },
  types: {
    type: "checkbox",
    order: 6,
    title: "Type",
    filterKey: "types",
    multiple: true,
    className: "product-list-filter-fitment",
    scrolling: false,
  },
  fitments: {
    type: "checkbox",
    order: 7,
    title: "Fitment",
    filterKey: "fitments",
    multiple: true,
    className: "product-list-filter-fitment",
    scrolling: false,
  },
  manufacturers: {
    type: "checkbox",
    order: 8,
    title: "Brand",
    filterKey: "manufacturers",
    multiple: true,
    // allLabel: (items) => renderAllLabel(items, "ALL MANUFACTURERS"),
    className: "product-list-filter-manufacturers",
  },
  diameters: {
    type: "checkbox",
    order: 9,
    title: "Diameter",
    filterKey: "diameters",
    multiple: true,
    className: "product-list-filter-diameter",
  },
  widths: {
    type: "checkbox",
    order: 10,
    title: "Width",
    filterKey: "widths",
    multiple: true,
    className: "product-list-filter-width",
  },
  boltPatterns: {
    type: "checkbox",
    order: 11,
    title: "Bolt Patterns",
    filterKey: "boltPatterns",
    multiple: true,
    className: "product-list-filter-fitment",
  },
  // https://partsavatar.ca/fluids-oils-lubricants
  oilGrades: {
    type: "checkbox",
    order: 12,
    title: "Oil Grades",
    filterKey: "oilGrades",
    multiple: true,
    className: "product-list-filter-fitment",
  },
  oilViscosities: {
    type: "checkbox",
    order: 12,
    title: "Oil Viscosities",
    filterKey: "oilViscosities",
    multiple: true,
    className: "product-list-filter-fitment",
  },
  oilVolumes: {
    type: "checkbox",
    order: 12,
    title: "Oil Volumes",
    filterKey: "oilVolumes",
    multiple: true,
    className: "product-list-filter-fitment",
  },
  offsets: {
    type: "checkbox",
    order: 11,
    title: "Offset",
    filterKey: "offsets",
    multiple: true,
    className: "product-list-filter-fitment",
  },
  colors: {
    type: "checkbox",
    order: 12,
    title: "Color",
    filterKey: "colors",
    multiple: true,
    className: "product-list-filter-fitment",
    scrolling: true,
  },
  prices: {
    type: "checkbox",
    order: 13,
    title: "Price",
    filterKey: "prices",
    multiple: true,
    itemValue: (item: any) => `${item.from}-${item.to}`,
    // allLabel: (items) => renderAllLabel(items, "ALL PRICES"),
    className: "product-list-filter-prices",
    scrolling: false,
  },
  availabilities: {
    type: "checkbox",
    order: 14,
    title: "Availability",
    filterKey: "availabilities",
    multiple: true,
    className: "product-list-filter-availability",
    scrolling: false,
  },
};
